import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getAvailabilityMinutes = async () => {
	const response = await api.get('/diaUtil/disponibilidadeMinutos');
	return response.data;
};
export const useAvailabilityMinutes = () => {
	return useQuery(['availability-minutes'], getAvailabilityMinutes, {
		refetchOnWindowFocus: false,
	});
};
